import api from '../services/config/api';

export interface IThirdPartyAssementChart {
  name: string;
  y: number;
  countTotal: number;
}
export interface IChartDashboard {
  series: [
    {
      data: [
        {
          name: string;
          y: number;
          countTotal: number;
        },
      ];
    },
  ];
}
export const getChartThirdPartyEvaluation = () =>
  api.get<IChartDashboard>('/lei-geral-protecao-de-dados/assessment-terceiros/pizzaChart');

export const getChartROPA = () =>
  api.get<IChartDashboard>('/lei-geral-protecao-de-dados/registro-das-operacoes/pizzaChart');

export const getChartALI = () =>
  api.get<IChartDashboard>('/lei-geral-protecao-de-dados/avaliacao-legitimo-interesse/pizzaChart');

export const getChartEvaluation = () =>
  api.get<IChartDashboard>('lei-geral-protecao-de-dados/questionario-novos-projetos/pizzaChart');
